import { createApp } from "vue";
import App from "./App.vue";

import router from "./router";
import store from "./store";

import dayjs from "dayjs";
import "dayjs/locale/fr";
import { createMetaManager } from "vue-meta";

dayjs.locale("fr");

//imports for app initialization
import StyleClass from "primevue/styleclass";
import ApiService from "@/core/services/ApiService";
import { resolveInitialSociete } from "@/config/societes";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import PrimeVue from "primevue/config";
import Aura from "@primevue/themes/aura";
import "primeicons/primeicons.css";

import "@/core/plugins/prismjs";
import VueEasyLightbox from "vue-easy-lightbox";
import ToastService from "primevue/toastservice";
import Tooltip from "primevue/tooltip";
import ConfirmationService from "primevue/confirmationservice";
const app = createApp(App);

// Sentry.init({
//   app,
//   dsn: "https://d8c29415b6604f6f8176561b2ebb8b8b@o4504320855375872.ingest.sentry.io/4504320862912512",
//   integrations: [
//     new BrowserTracing({
//       routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//       tracePropagationTargets: ["egesparc.jugandautos.com", /^\//],
//     }),
//   ],
//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
// });

app.use(store);
app.use(router);
app.use(createMetaManager());
app.use(VueEasyLightbox);
// Attributs d'opt-out pour décourager les extensions Chrome (autofill,
// gestionnaires de mots de passe, Grammarly) de se greffer aux champs et
// d'en casser le fonctionnement. Appliqués globalement via le passthrough.
const noExtensionAttrs = {
  autocomplete: "off",
  autocorrect: "off",
  autocapitalize: "off",
  spellcheck: "false",
  "data-1p-ignore": "true",
  "data-lpignore": "true",
  "data-form-type": "other",
  "data-gramm": "false",
  "data-gramm_editor": "false",
  "data-enable-grammarly": "false",
};

app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      prefix: "p",
      darkModeSelector: "none",
      cssLayer: false,
    },
  },
  locale: {
    clear: "Effacer",
    apply: "Appliquer",
    startsWith: "Commence par",
    contains: "Contient",
    notContains: "Ne contient pas",
    endsWith: "Finit par",
    equals: "Egale à",
    notEquals: "N'est pas égale à",
    noFileChosenMessage: "Aucun fichier choisi",
    choose: "Choisir un fichier",
    dayNames: [
      "Dimanche",
      "Lundi",
      "Mardi",
      "Mercredi",
      "Jeudi",
      "Vendredi",
      "Samedi",
    ],
    dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
    dayNamesMin: ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
    monthNames: [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août",
      "Septembre",
      "Octobre",
      "Novembre",
      "Décembre",
    ],
    monthNamesShort: [
      "Jan",
      "Fév",
      "Mar",
      "Avr",
      "Mai",
      "Jui",
      "Jui",
      "Aoû",
      "Sep",
      "Oct",
      "Nov",
      "Déc",
    ],
    chooseYear: "Choisir l'année",
    chooseMonth: "Choisir le mois",
    chooseDate: "Choisir la date",
    prevDecade: "10ans avant",
    nextDecade: "10ans après",
    prevYear: "Année précédente",
    nextYear: "Année suivante",
    prevMonth: "Mois précédent",
    nextMonth: "Mois suivante",
    prevHour: "Heure précédente",
    nextHour: "Heure suivante",
    prevMinute: "Minute précédente",
    nextMinute: "Minute suivante",
    prevSecond: "Seconde précédente",
    nextSecond: "Seconde suivante",
    am: "am",
    pm: "pm",
    today: "Aujourd'hui",
    weekHeader: "Semaine",
  },
  pt: {
    inputtext: { root: noExtensionAttrs },
    textarea: { root: noExtensionAttrs },
    inputnumber: { pcInputText: { root: noExtensionAttrs } },
    password: { pcInputText: { root: noExtensionAttrs } },
    select: { label: noExtensionAttrs, pcFilter: { root: noExtensionAttrs } },
    multiselect: { pcFilter: { root: noExtensionAttrs } },
    autocomplete: { pcInputText: { root: noExtensionAttrs } },
    datepicker: { pcInputText: { root: noExtensionAttrs } },
  },
});
app.directive("styleclass", StyleClass);
app.directive("tooltip", Tooltip);
app.use(ToastService);
app.use(ConfirmationService);
store.commit(
  "domain/setSelectedSociete",
  resolveInitialSociete(
    window.localStorage.getItem("selected_societe"),
    store.getters.getCurrentUser?.societe,
    window.location.hostname
  )
);

ApiService.init(app);
initInlineSvg(app);
initVeeValidate();

app.mount("#app");
